// rater-form.service.ts
import { Injectable }        from '@angular/core';
import { HttpClient }        from '@angular/common/http';
import { Observable , throwError }        from 'rxjs';
import { catchError }        from 'rxjs/operators'
import { environment }       from '../../environments/environment';
import { FormData }          from '../_models/form-questions.interface';

@Injectable({ providedIn: 'root' })
export class RaterFormService {
     private apiUrl = environment.apiurl;        
     private referralUrl = environment.gdocsurl;
     private env = (environment.production === true) ? "app" : "dev" ;

  constructor(private http: HttpClient) {}

  getFormQuestions(linkval: string): Observable<FormData> {
    //console.log('link:', linkval);
    return this.http.get<FormData>(`${this.apiUrl}/form/questions`, {
      params: { linkval }
    }).pipe(
      catchError(err => {
        const errorBody = err.error;
        const message   = (errorBody && errorBody.error)
                          ? errorBody.error
                          : 'Invalid or expired link.';
        return throwError(() => ({ message, status: err.status }));
      })
    );
  }

  submitForm(payload: any): Observable<any> {
    payload.ops = "submitRaterForm";
    return this.http.post(`${this.apiUrl}/form/submit`, payload).pipe(
      catchError(err => {
        const errorBody = err.error;
        const message   = (errorBody && errorBody.error)
                          ? errorBody.error
                          : 'Submission failed. Please try again.';
        return throwError(() => ({ message, status: err.status }));
      })
    );
  }
}